/**
 * 无权限处理器(403)
 */
export interface UnauthorizedHandler {
    handle(error: Error): void;
}

export const UnauthorizedHandler = Symbol('UnauthorizedHandler');
